import React, { useContext, useMemo } from "react";
import "./App.css";
import Router from "./routes";
import { BrowserRouter as Routers } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import AlertMessage from "./Component/AlertMessage/AlertMessage";
import { setContext } from "@apollo/client/link/context";
import { AuthContext } from "./context/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";

function App() {
  const { state } = useContext(AuthContext);
  const { user } = state;

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: "light",
          background: {
            default: "#F4F6F6",
          },
        },
        typography: {
          fontFamily: ["Century Gothic", "Siemreap"].join(","),
        },
      }),
    []
  );

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_END_POINT,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: user ? user?.token : "",
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  const queryClient = new QueryClient();

  return (
    <ApolloProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Routers>
            <Router />
          </Routers>
          <CssBaseline />
        </ThemeProvider>
      </QueryClientProvider>
      <AlertMessage />
    </ApolloProvider>
  );
}

export default App;
